<template>
  <div class="business-card">
    <img class="logo" src="@/assets/images/logo.png" alt="Logo" />

    <div class="info-container">
      <div class="info-text">
        <img src="@/assets/images/name.png" alt="Mahinour Elsayed" />
        <h2>Technical Recruiter</h2>
        <h3 class="uppercase">Monglish</h3>
        <h3>+20 101 815 8118</h3>
        <h3>mahinour.elsayyed@monglish.uk</h3>
      </div>

      <div class="contact-image">
        <div class="social-icons">
          <a
            href="https://www.linkedin.com/in/mahinour-elsayed-9177b4276/"
            target="_blank"
            class="linkedin-icon"
          >
            <img src="@/assets/images/linkedin-icon.png" alt="LinkedIn" />
          </a>
          <span class="separator">|</span>
          <a
            href="https://www.facebook.com/share/1DJhyJnV8d/"
            target="_blank"
            class="facebook-icon"
          >
            <img src="@/assets/images/fb.png" alt="Facebook" />
          </a>
        </div>
        <img src="@/assets/images/contact-desk.png" alt="Contact" class="mob" />
      </div>
    </div>
        <footer class="footer1">
      <a href="https://monglish.co.uk/" target="_blank">monglish.co.uk</a>
    </footer>
  </div>

  <footer class="footer">
    <a href="https://monglish.co.uk/" target="_blank">monglish.co.uk</a>
  </footer>
</template>

<script>
export default {
  name: "BusinessCard",
};
</script>

<style scoped>
.business-card {
  width: 100%;
  height: 95vh;
  background-size: cover;
  background-position: center;
  background-image: url("@/assets/images/desk.png");
  position: relative;
}

.logo {
  position: absolute;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
  display: block;
  max-width: 200px;
  z-index: 10;
}

.info-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: absolute;
  top: 120px;
  left: 50%;
  transform: translateX(-50%);
  width: 80%;
}

.info-text {
  width: 50%;
  color: white;
  text-align: right;
  margin-right: 20px;
}

.info-text img {
  width: 100%;
}

h2 {
  color: #155d83;
  font-size: 40px;
  text-transform: uppercase;
}

h3:first-of-type {
  color: #155d83;
  font-size: 30px;
  font-weight: 300;
  text-transform: uppercase;
}

h3:not(:first-of-type) {
  color: #3d3d3d;
  font-size: 26px;
  font-weight: 300;
}

.uppercase {
  margin-top: -10px;
}

.contact-image {
  width: 38%;
  position: relative;
}

.contact-image img {
  max-width: 80%;
  height: auto;
}

.social-icons {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 4.6%;
  left: 40%;
  transform: translateX(-50%);
  z-index: 10;
}

.social-icons img {
  width: 20px;
  height: 20px;
}

.separator {
  color: black;
  font-size: 24px;
  margin: 0 15px;
}

.footer {
  background-color: #155d83;
  height: 5vh;
  font-size: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.footer a {
  color: white;
  text-decoration: none;
  font-weight: bold;
}

.footer1 {
  display: none;
}

@media (max-width: 1440px) {
  .contact-image img {
    max-width: 100%;
  }

  .social-icons {
    justify-content: center;
    top: 4.6%;
    left: 51%;
  }

  .separator {
    font-size: 25px;
  }
}

@media (max-width: 1280px) {
  .contact-image img {
    max-width: 80%;
  }

  h2 {
    font-size: 36px;
  }

  h3:first-of-type {
    font-size: 28px;
  }

  h3:not(:first-of-type) {
    font-size: 24px;
  }

  .social-icons {
    top: 4.6%;
    left: 41%;
  }

  .social-icons img {
    width: 15px;
    height: 15px;
  }

  .separator {
    font-size: 20px;
  }
}

@media (max-width: 768px) {
  .business-card {
    background-image: url("@/assets/images/mob.png");
    height: 100vh;
    overflow: hidden;
  }

  .logo,
  .info-text img {
    display: none;
  }

  .info-container {
    flex-direction: column-reverse;
    text-align: center;
  }

  .contact-image {
    width: 380px;
  }

  .info-text {
    width: 100%;
    text-align: center;
  }

 h2 {
    font-size: 22px;
    line-height: 30px;
  }

  h3:first-of-type {
    font-size: 20px;
    line-height: 20px;
  }

  h3:not(:first-of-type) {
    font-size: 18px;
    line-height: 16px;
  }

  .mob {
    margin-top: -15px;
    content: url("@/assets/images/contact-mob.png");
  }

  .social-icons {
    top: 1.3%;
    left: 50%;
  }

  .social-icons img {
    width: 20px;
    height: 20px;
  }

  .separator {
    font-size: 18px;
  }

  .footer {
    display: none;
  }

  .footer1 {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    bottom: 25px;
    left: 0;
    right: 0;
    background: none;
    font-size: 18px;
  }

  .footer1 a {
    color: white;
    text-decoration: none;
  }
}
</style>
